import { render, staticRenderFns } from "./cwzdgl.vue?vue&type=template&id=427bf86e&scoped=true&"
import script from "./cwzdgl.vue?vue&type=script&lang=js&"
export * from "./cwzdgl.vue?vue&type=script&lang=js&"
import style0 from "./cwzdgl.vue?vue&type=style&index=0&id=427bf86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bf86e",
  null
  
)

export default component.exports